import { Component, OnDestroy, OnInit } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';
import { animate, style, transition, trigger, state } from '@angular/animations';

@Component({
  selector: 'coro-card-wrapper',
  templateUrl: './coro-card-wrapper.component.html',
  styleUrls: ['./coro-card-wrapper.component.scss'],
  standalone: false,
  animations: [
    trigger('slideToggle', [
      state(
        'closed',
        style({
          display: 'none',
          height: '0',
          opacity: '0',
          overflow: 'hidden',
          visibility: 'hidden',
        }),
      ),
      state(
        'open',
        style({
          height: '*',
          opacity: '1',
          visibility: 'visible',
        }),
      ),
      transition('closed => open', [
        style({ height: '0', opacity: '0', overflow: 'hidden', visibility: 'visible' }),
        animate('300ms ease-out'),
      ]),
      transition('open => closed', [style({ overflow: 'hidden' }), animate('300ms ease-in')]),
    ]),
  ],
})
export class CoroCardWrapperComponent extends BlockAbstractComponent implements OnInit, OnDestroy {
  cards: any[] = [];
  isExpanded = false;
  readonly maxVisibleCards = 3; // Made accessible to the template

  override ngOnInit(): void {
    super.ngOnInit();
    this.cards = this.block.content ?? [];
  }

  getMegaCardBlocks(): any[] {
    return this.cards.map(card => card?.content?.[0]?.content?.[0]).filter(c => c?.data);
  }

  hasMoreCards(): boolean {
    const allCards = this.cards.map(card => card?.content?.[0]?.content?.[0]).filter(c => c?.data);
    return allCards.length > this.maxVisibleCards;
  }

  toggleView(): void {
    this.isExpanded = !this.isExpanded;
  }
}
